import { randomNumber } from '../../../utilities'
import { SpecialReportsConstants } from './specialReports.constants'
import { ISpecialReportsState, ISpecialReportsAction, ISpecialReport } from './specialReports.types'

export const SPECIAL_REPORTS_MODULE_ID = 10

export const initialSpecialReport = (): ISpecialReport => {
  return {
    id: randomNumber().toString(),
    reportType: '',
    ruleId: '',
    completed: false,
    dateOccurred: '',
    dateReported: '',
    author: null,
    recordNumber: '',
    crew: [],
    base: null,
    unit: null,
    supervisor: null,
    personnelIssue: null,
    isUrgent: false,
    isFlagReport: false,
    subject: '',
    categories: [],
    subCategories: [],
    customQuestions: [],
    narrative: '',
    comments: '',
    autoEmail: [],
    extraEmail: [],
    reportReviewedBy: '',
    status: null,
  }
}

export const initialSpecialReportsState: ISpecialReportsState = {
  ...initialSpecialReport(),
  __currentStep: 1,
  __currentSubStep: 1,
  __deleteSpecialReportId: '',
  specialReportsList: [],
}

export function specialReportsReducer(
  state: ISpecialReportsState = initialSpecialReportsState,
  action: ISpecialReportsAction
): ISpecialReportsState {
  switch (action.type) {
    case SpecialReportsConstants.SET_CURRENT_STEP:
      return { ...state, __currentStep: action.__currentStep || 1, __currentSubStep: 1 }
    case SpecialReportsConstants.SET_CURRENT_SUB_STEP:
      return { ...state, __currentSubStep: action.__currentSubStep || 1 }
    case SpecialReportsConstants.SET_DATE_OCCURRED:
      return { ...state, dateOccurred: action.dateOccurred }
    case SpecialReportsConstants.SET_DATE_REPORTED:
      return { ...state, dateReported: action.dateReported }
    case SpecialReportsConstants.SET_AUTHOR:
      return { ...state, author: action.author }
    case SpecialReportsConstants.SET_RECORD_NUMBER:
      return { ...state, recordNumber: action.recordNumber }
    case SpecialReportsConstants.SET_CREW:
      return { ...state, crew: action.crew }
    case SpecialReportsConstants.SET_BASE:
      return { ...state, base: action.base }
    case SpecialReportsConstants.SET_UNIT:
      return { ...state, unit: action.unit }
    case SpecialReportsConstants.SET_SUPERVISOR:
      return { ...state, supervisor: action.supervisor }
    case SpecialReportsConstants.SET_PERSONNEL_ISSUE:
      return { ...state, personnelIssue: action.personnelIssue }
    case SpecialReportsConstants.SET_IS_URGENT:
      return { ...state, isUrgent: action.isUrgent }
    case SpecialReportsConstants.SET_IS_FLAG_REPORT:
      return { ...state, isFlagReport: action.isFlagReport }
    case SpecialReportsConstants.SET_SUBJECT:
      return { ...state, subject: action.subject }
    case SpecialReportsConstants.SET_CATEGORIES:
      return { ...state, categories: action.categories }
    case SpecialReportsConstants.SET_SUB_CATEGORIES:
      return { ...state, subCategories: action.subCategories }
    case SpecialReportsConstants.SET_CUSTOM_QUESTIONS:
      return { ...state, customQuestions: action.customQuestions }
    case SpecialReportsConstants.SET_NARRATIVE:
      return { ...state, narrative: action.narrative }
    case SpecialReportsConstants.SET_COMMENTS:
      return { ...state, comments: action.comments }
    case SpecialReportsConstants.SET_AUTO_EMAIL:
      return { ...state, autoEmail: action.autoEmail }
    case SpecialReportsConstants.SET_EXTRA_EMAIL:
      return { ...state, extraEmail: action.extraEmail }
    case SpecialReportsConstants.SET_REPORT_REVIEWED_BY:
      return { ...state, reportReviewedBy: action.reportReviewedBy }
    case SpecialReportsConstants.SET_STATUS:
      return { ...state, status: action.status }
    case SpecialReportsConstants.SET_REPORT_TYPE:
      return { ...state, reportType: action.reportType }
    case SpecialReportsConstants.SET_RULE_ID:
      return { ...state, ruleId: action.ruleId }
    case SpecialReportsConstants.SET_SPECIAL_REPORT:
      return { ...action.specialReportsState, __currentStep: action.specialReportsState.__currentStep || 1 }
    case SpecialReportsConstants.RESET_SPECIAL_REPORTS:
      return {
        ...initialSpecialReport(),
        __currentStep: 1,
        __currentSubStep: 1,
        __deleteSpecialReportId: '',
        specialReportsList: state.specialReportsList,
      }
    case SpecialReportsConstants.RESET_SPECIAL_REPORTS_ON_CHART_EXIT:
      return initialSpecialReportsState
    case SpecialReportsConstants.DELETE_SPECIAL_REPORT:
      return { ...state, __deleteSpecialReportId: action.id }
    case SpecialReportsConstants.SET_SPECIAL_REPORTS_LIST:
      return { ...state, specialReportsList: action.specialReportsList }
    case SpecialReportsConstants.SET_COMPLETED:
      return { ...state, completed: action.completed }
    default:
      return state
  }
}
